import React from "react";
import apiUrl from "../../Apiurl";
import stilePulsanti from "../../interfaccia/stilePulsanti";
import RitentaErroriDashboard from "./RitentaErroriDashboard";

const inputClassName = "input-reset ba b--black-20 br2 pa2 w-100";
const selectClassName = "ba b--black-20 br2 pa2 w-100 sfondoBiancoTema";

function BarraDashboard({
  token,
  aggiorna,
  filtri,
  cambiaFiltroColonna,
  soloErrori,
  cambiaFiltroErrori,
  includiMassive,
  cambiaInclusioneMassive,
}) {
  const forzaSync = async function () {
    if (!token) {
      console.warn("sto aspettando un token");
      return;
    }
    await fetch(apiUrl + "/prodotti/ps/forzaSync", {
      headers: { Authorization: "Bearer " + token },
      method: "PATCH",
    });
    aggiorna();
  };

  const renderSelectBooleano = (nome, etichetta) => (
    <label className="f7 mr2 mb2" style={{ width: "7rem" }}>
      <span className="db mb1">{etichetta}</span>
      <select
        className={selectClassName}
        value={filtri[nome]}
        onChange={(event) => cambiaFiltroColonna(nome, event.target.value)}
      >
        <option value="">Tutti</option>
        <option value="1">Sì</option>
        <option value="0">No</option>
      </select>
    </label>
  );

  return (
    <div className="formRicercaOrizzontale pa2">
      <div className="flex flex-wrap items-end w-100">
        <label className="f7 mr2 mb2" style={{ width: "10rem" }}>
          <span className="db mb1">Data inserimento</span>
          <input
            type="search"
            className={inputClassName}
            value={filtri.dataInserimento}
            onChange={(event) =>
              cambiaFiltroColonna("dataInserimento", event.target.value)
            }
            placeholder="gg/mm/aaaa"
          />
        </label>
        <label className="f7 mr2 mb2" style={{ width: "9rem" }}>
          <span className="db mb1">Codice VS</span>
          <input
            type="search"
            className={inputClassName}
            value={filtri.codVS}
            onChange={(event) =>
              cambiaFiltroColonna("codVS", event.target.value)
            }
            placeholder="Codice VS"
          />
        </label>
        <label className="f7 mr2 mb2" style={{ width: "7rem" }}>
          <span className="db mb1">Sito</span>
          <select
            className={selectClassName}
            value={filtri.fonte}
            onChange={(event) =>
              cambiaFiltroColonna("fonte", event.target.value)
            }
          >
            <option value="">Tutti</option>
            <option value="VIG">VIG</option>
            <option value="BOT">BOT</option>
          </select>
        </label>
        <label className="f7 mr2 mb2" style={{ width: "13rem" }}>
          <span className="db mb1">Tipo</span>
          <input
            type="search"
            className={inputClassName}
            value={filtri.tipoSync}
            onChange={(event) =>
              cambiaFiltroColonna("tipoSync", event.target.value)
            }
            placeholder="Tipo sincronizzazione"
          />
        </label>
        {renderSelectBooleano("toSync", "Da sinc.")}
        {renderSelectBooleano("success", "Ok")}
        {renderSelectBooleano("error", "Err")}
        <label className="f7 mr2 mb2" style={{ width: "10rem" }}>
          <span className="db mb1">Data operazione</span>
          <input
            type="search"
            className={inputClassName}
            value={filtri.dataOperazione}
            onChange={(event) =>
              cambiaFiltroColonna("dataOperazione", event.target.value)
            }
            placeholder="gg/mm/aaaa"
          />
        </label>
        <label className="f7 mr2 mb2" style={{ width: "10rem" }}>
          <span className="db mb1">Utente</span>
          <input
            type="search"
            className={inputClassName}
            value={filtri.utente}
            onChange={(event) =>
              cambiaFiltroColonna("utente", event.target.value)
            }
            placeholder="Username"
          />
        </label>
      </div>

      <div className="flex justify-end flex-wrap items-center mt1">
        <RitentaErroriDashboard token={token} aggiorna={aggiorna} />
        <div
          className="dim pointer gruppoInputRicercaOrizzontale mr2"
          onClick={aggiorna}
        >
          <button className="dim tastoInputOrizzontale br3">
            {stilePulsanti.tastoRefreshAspetto}
          </button>
          <div className="ml2">Aggiorna</div>
        </div>
        <div
          className="dim pointer gruppoInputRicercaOrizzontale mr2"
          onClick={forzaSync}
        >
          <button className="tastoInputOrizzontale br3">
            {stilePulsanti.tastoForzaAspetto}
          </button>
          <div className="ml2">Forza sync</div>
        </div>
        <div
          className="dim pointer gruppoInputRicercaOrizzontale mr2"
          onClick={cambiaFiltroErrori}
        >
          <button className="tastoInputOrizzontale br3">
            {stilePulsanti.tastoErroreAspetto}
          </button>
          <div className="ml2">
            {soloErrori ? "Mostra tutte" : "Mostra problemi"}
          </div>
        </div>
        <div
          className="dim pointer gruppoInputRicercaOrizzontale mr2"
          onClick={cambiaInclusioneMassive}
        >
          <button className="tastoInputOrizzontale br3">MM</button>
          <div className="ml2">
            {includiMassive ? "Escludi massive" : "Includi massive"}
          </div>
        </div>
      </div>
    </div>
  );
}

export default BarraDashboard;
